import React from "react";
import { Typography } from "@aph/ui-lib-humanx";
import NextLink from "next/link";
import IconRightArrow from "$/icons/icon_rightArrow.svg";
import Image from "@/components/Image";
import styles from "./menu.module.scss";

interface MenuListProps {
  title?: string;
  titleIconUrl?: string;
  isHeadNav?: boolean;
  isActive?: boolean;
  collapsible?: boolean;
  onClick?: (e?: any) => void;
  ctaUrl?: string;
}

const MenuList: React.FC<MenuListProps> = (props) => {
  const { title, titleIconUrl, isHeadNav, collapsible, isActive, onClick, ctaUrl } = props;

  return (
    <div className={`${styles.linkRoot} ${isHeadNav ? styles.headerLink : ""} ${isActive ? styles.active : ""}`}>
      <div className={styles.leftBx} onClick={onClick}>
        <span className={styles.icon}>{collapsible && <i className={styles.arrow} />}</span>
        <Typography className={styles.title}>
          {titleIconUrl && (
            <span className={styles.textRelatedImageWrapper}>
              <Image src={titleIconUrl} alt="icon" height={32} width={32} className={styles.textRelatedImage} />
            </span>
          )}
          {title}
        </Typography>
      </div>
      <NextLink prefetch={false} href={ctaUrl} className={styles.righArrow}>
        <IconRightArrow width={24} height={24} />
      </NextLink>
    </div>
  );
};

export default MenuList;
